import { ComponentWithTooltip } from 'components/ComponentWithTooltip';
import { IconAlert, Text } from 'uikit';

import type { ReactNode } from 'react';

export const ValueOrServiceMessage = <T extends { result: boolean; data?: any; message?: string | undefined | null }>({
    serviceData,
    displayValue,
}: {
    serviceData: T | null | undefined;
    displayValue: ReactNode;
}) => {
    const { result, message } = serviceData ?? {};

    if (!result) {
        return message ? (
            <ComponentWithTooltip
                tooltipText={message}
                styles={{
                    width: 'max-content',
                }}
            >
                <IconAlert view="alert" />
            </ComponentWithTooltip>
        ) : (
            <IconAlert view="alert" />
        );
    }

    return <Text size="s">{displayValue}</Text>;
};

ValueOrServiceMessage.displayName = 'ValueOrServiceMessage';
